export default "__VITE_ASSET__DP1fp_gN__"